import { useFormik } from 'formik';
import * as Yup from 'yup';

import { TextFieldStyled } from '../../../../shared/components';
import { EditFormActionWrapper, EditFormProps, useEditFormStyles } from '.';

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email address').required('Required'),
});

export const EditCareProviderForm: React.FC<EditFormProps> = ({
  userToEdit,
  editUser,
  closeDialog,
  openRemoveUserDialog,
}) => {
  const classes = useEditFormStyles();
  const { name = '', email = '' } = userToEdit;
  const initialValues = {
    name,
    email,
  };

  const { touched, errors, values, handleSubmit, handleChange } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      closeDialog();
      editUser({
        ...userToEdit,
        ...values,
      });
    },
  });

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      <div className={classes.textFieldsWrapper}>
        <TextFieldStyled
          id="name"
          name="name"
          label="Name"
          type="text"
          helperText={touched.name ? errors.name : ''}
          error={touched.name && Boolean(errors.name)}
          variant="outlined"
          onChange={handleChange}
          value={values.name}
        />
        <TextFieldStyled
          id="email"
          name="email"
          label="Email"
          type="email"
          helperText={errors.email}
          error={Boolean(errors.email)}
          variant="outlined"
          onChange={handleChange}
          value={values.email}
        />
      </div>
      <EditFormActionWrapper
        deleteText="Delete Provider"
        closeDialog={closeDialog}
        openRemoveUserDialog={openRemoveUserDialog}
        didInputsChange={initialValues !== values}
      />
    </form>
  );
};
